import type { ReactNode } from 'react';
import { BillReviewStage } from './BillReviewStage.js';

/** The commercial check of a forwarded bill: the work, area, terms, rates and documents. */
export function CommercialReviewPage(): ReactNode {
  return (
    <BillReviewStage
      stage="commercial"
      checks={['workCompletionOk', 'areaValidationOk', 'commercialComplianceOk', 'rateComplianceOk', 'documentCompletenessOk']}
      decisions={['APPROVE', 'REJECT', 'RETURN', 'ESCALATE']}
    />
  );
}
